import { BaseService } from 'core/services';
import BranchRouteService from './BranchRouteService';

class BranchService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new BranchRouteService());
    }
}

export default BranchService;
